import React from 'react';
import { useParams } from 'react-router-dom';

import UserDetailsContainer from '@totem/components/users/details/UserDetailsContainer';
import UserDetailsLayout from '@totem/components/users/details/UserDetailsLayout';

const UserDetailsPage = () => {
  const { id } = useParams();

  return (
    <UserDetailsContainer userId={id}>
      <UserDetailsLayout />
    </UserDetailsContainer>
  );
};

export default UserDetailsPage;
